// start:ng42.barrel
import './location-lite.component';
// end:ng42.barrel

